// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/flask-conical.js';

import { paths } from '../generated/flask-conical';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('flask-conical', Original, paths);
